import React from 'react';
import NavBadge from './NavBadge';
import useCustomerRequests from '../../hooks/useCustomerRequests';

// item 868a — the Customer Requests nav badge (the accountant-badge pattern): a red count of
// SUBMITTED portal requests awaiting review, or the green check when the queue is clear.
// Mounts only on the tool row (admins), so its query never runs for users who can't see it.
const CustomerRequestsNavBadge: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const { submittedCount, isLoading } = useCustomerRequests();
  if (isLoading) return null;
  return <NavBadge count={submittedCount} caughtUp={submittedCount === 0} collapsed={collapsed} />;
};

CustomerRequestsNavBadge.defaultProps = { collapsed: false };

export default CustomerRequestsNavBadge;
